export default {
    state: {
        endpoint: "wolkvox",
    },
    getters: {
        endpoint: (state) => state.endpoint,
    },
    mutations: {
    },
    actions: {
        colgarLlamada({ state }, payload) {
            return new Promise((res, rej) => {
                this.dispatch('index', { endpoint: state.endpoint + '/colgar', params: payload })
                .then((response) => {
                    res(response)
                })
                .catch((error) => {
                    rej(error)
                })
            });
        }
    }
}